import _objectSpread2 from "@babel/runtime/helpers/objectSpread";
import cookieDough from 'cookie-dough';
import dayjs from 'dayjs';
import * as C from './scenarios/constants';
var cookie = cookieDough();

var timeout = function timeout(period, times, scenario) {
  var scenarioSession = window.sessionStorage.getItem(C.CHATBOT_SCENARIOS);
  var scenarioCookie = cookie.all();

  switch (period) {
    case C.PERIOD_SESSION:
      return checkSession(times, scenario, JSON.parse(scenarioSession || '{}'));

    case C.PERIOD_LOGIN:
      return checkLogin(times, scenario, JSON.parse(scenarioCookie[C.CHATBOT_SCENARIOS] || '{}'));

    case C.PERIOD_DAYS:
      return checkDays(times, scenario, JSON.parse(scenarioCookie[C.CHATBOT_SCENARIOS] || '{}'));

    case C.PERIOD_ONCE:
      return checkOnce(times, scenario, JSON.parse(scenarioCookie[C.CHATBOT_SCENARIOS] || '{}'));

    case C.PERIOD_MINUTES:
      return checkMinutes(times, scenario, scenarioSession);

    default:
      return false;
  }
};

var checkOnce = function checkOnce(times, scenario) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data[scenario]) {
    return false;
  }

  var newData = _objectSpread2({}, data);

  newData[scenario] = 1;
  cookie.set(C.CHATBOT_SCENARIOS, JSON.stringify(newData));
  return true;
};

var checkSession = function checkSession(times, scenario) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data[scenario]) {
    return false;
  }

  var newData = _objectSpread2({}, data);

  newData[scenario] = true;
  window.sessionStorage.setItem(C.CHATBOT_SCENARIOS, JSON.stringify(newData));
  return true;
};

var checkLogin = function checkLogin(times, scenario) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data[scenario] && data[scenario] < times) {
    var _newData = _objectSpread2({}, data);

    _newData[scenario]++;
    cookie.set(C.CHATBOT_SCENARIOS, JSON.stringify(_newData));
    return false;
  }

  var newData = _objectSpread2({}, data);

  newData[scenario] = 1;
  cookie.set(C.CHATBOT_SCENARIOS, JSON.stringify(newData));
  return true;
};

var checkDays = function checkDays(times, scenario) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data[scenario] && dayjs(data[scenario]).diff(dayjs(), 'day') < times) {
    return false;
  }

  var newData = _objectSpread2({}, data);

  newData[scenario] = dayjs().format();
  cookie.set(C.CHATBOT_SCENARIOS, JSON.stringify(newData));
  return true;
};

var checkMinutes = function checkMinutes(times, scenario) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data[scenario] && dayjs(data[scenario]).diff(dayjs(), 'minute') < times) {
    return false;
  }

  var newData = _objectSpread2({}, data);

  newData[scenario] = dayjs().format();
  window.sessionStorage.setItem(newData);
  return true;
};

export default timeout;